import React from "react";
import AboutContent from "../FunctionComponents/AboutFolder/AboutContent";

function About() {
  return (
    <>
      <AboutContent />
    </>
  );
}

export default About;
